/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AxiosResponse, ResponseType } from 'axios';

import customAxios from './customAxios';
import { env } from '../constants/env';

export function getBaseURL(): string {
  // return env.NEXT_PUBLIC_API_URI || '';
  return process.env.NEXT_PUBLIC_API_URI || '';
}

/**
 * @description get url by service informed.
 * @param service is the service that fetch requires.
 * @returns base url.
 */

type TFetchParams = {
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  path: string;
  headers?: Record<string, any>;
  params?: Record<string, any>;
  data?: any;
  responseType?: ResponseType;
};
/**
 * @description makes http request according to the informed data.
 * @param param request params.
 * @returns fetch function.
 */
function fetch<T = any>({
  method = 'GET',
  path,
  params,
  headers,
  responseType,
  data,
}: TFetchParams): Promise<AxiosResponse<T>> {
  return new Promise((resolve, reject) => {
    customAxios({
      headers: {
        ...headers,
      },
      url: `${getBaseURL()}${path}`,
      method,
      params,
      responseType,
      data,
      paramsSerializer: {
        indexes: null, // no brackets at all
      },
      // withCredentials: true,
    })
      .then((response: any) => {
        resolve(response);
      })
      .catch((error: any) => {
        reject(error);
      });
  });
}

export function isLocalHost(): boolean {
  return getBaseURL().includes('localhost');
}

export default fetch;
